import { useEffect } from 'react';
import { useAppSettings } from '../../contexts/AppSettingsContext';
import useFavicon from '../../hooks/useFavicon';

const AppHead = ({ pageTitle = '' }) => {
    const { getAppName, getFaviconUrl, getAppDescription } = useAppSettings();
    
    // Update favicon
    useFavicon(getFaviconUrl());
    
    // Update document title
    useEffect(() => {
        const appName = getAppName();
        if (pageTitle) {
            document.title = `${pageTitle} - ${appName}`;
        } else {
            document.title = appName;
        }
    }, [pageTitle, getAppName]);

    // Update meta description
    useEffect(() => {
        const description = getAppDescription();
        if (description) {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.name = 'description';
                document.head.appendChild(metaDescription);
            }
            metaDescription.content = description;
        }
    }, [getAppDescription]);

    return null; // This component doesn't render anything
};

export default AppHead;